<template>
  <div class="home-widget">
    <div v-if="isMessage" class="home-widget-message"> <p :style="messageSize ? `font-size: ${messageSize}` : ''"> "{{description}}" </p></div>
    <div v-else-if="video && !$vuetify.breakpoint.mdAndDown" class="home-widget-video" :style="``">
      <video id="trainingVideo" @mouseenter="play()" width="100%" height="auto" :src="video" muted>
      </video>
      <div v-html="getHeader()" style="position: absolute; padding: 10px"> </div>
    </div>

    <div v-else :class="`${noHover ? '' : 'home-widget-content'}`" :style="`${header ? 'background: linear-gradient(to bottom,rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.8),rgba(0, 0, 0, 1))' : ''}; ${$vuetify.breakpoint.smAndDown ? 'opacity: 1' : ''}`">
      <!-- <v-img class="home-widget-image" src="@/assets/tools.jpg"/> -->
      <div v-html="getHeader()" class="home-widget-header" :style="`${$vuetify.breakpoint.smAndDown ? 'hyphens: manual' : 'hyphens: manual'}`"></div>

      <div v-if="!$vuetify.breakpoint.mdAndDown"> {{description}} </div>
      <slot/>
    </div>

  </div>
</template>

<script>
export default {
  props: ['header', 'description', 'noHover', 'isMessage', 'messageSize', 'video'],
  data: function() {
    return {
    }
  },
  methods: {
    getHeader() {
      if(this.header === undefined || this.header === '') {
        return '';
      }
      return this.header.join('<wbr>')
    },
    play() {
      document.getElementById("trainingVideo").play();
    }
  }
}

</script>

<style>
.home-widget-content {

  /* backdrop-filter: blur(5px); */
  padding: 10px;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: baseline;
  /* background-color: red; */
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
}
.home-widget-header {
  /* display:flex;
  flex-direction: row; */
  width: 100%;
  font-size: 26px;
  font-weight: 700;
  margin: 0px;
  /* overflow-x: auto;
  flex-wrap: nowrap; */
  /* word-wrap: break-word; */
  /* hyphens: auto; */
}
.home-widget-message {
  padding: 5%;
  hyphens: manual;
  text-align: justify;
  vertical-align: middle;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  text-align: center;
  font-family: "Georigia", serif;
  font-size: 38px;
  font-style: italic;
}
.home-widget-video {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: baseline;
  width: 100%;
  font-size: 0px;
  font-weight: 700;
  margin: 0px;
}
.home-widget:hover .home-widget-video {
  font-size: 26px;
}
.home-widget {
  overflow: hidden;
  /* height: 100%;
  width: 100%;
  border: solid 1px white;
  border-radius: 20px; */



  cursor: pointer;
}
.home-widget:hover .home-widget-content {
  opacity: 1;
}
.background-image {
  background-size: 130%;
  height: 100%;
  width: 100%;
  border-radius: 20px;
}
/* .home-widget-image {
  position: absolute;
  height: 100%;
  width: 100%;
} */
</style>
